import * as React from 'react';
import { translate, ITranslationsCollection } from 'elc-service';
import { observer } from 'mobx-react';
import { Sku } from '../../domain/entities/Sku';
import styled from 'styled-components';
import { ContentSpacing } from 'elc-base-theme';
import { classes } from '../../utils/Classes';
import { observable } from 'mobx';
import { serviceNames, lazyInject } from '../../../service-setup/diContainer';
import { ProductEngravingViewController } from '../../controllers/ProductEngravingViewController';

export interface IProductEngraving {
    className?: string;
    translations?: ITranslationsCollection;
    selectedSku: Sku;
}

const StyledEngraveContent = styled.div`
    margin: ${ContentSpacing.space16} ${ContentSpacing.space8} 0;
`;

const StyledEngraveLink = styled.a`
    cursor: pointer;
`;

@translate(['engravingModalLabel', 'engravingLink'])
@observer
export class ProductEngraving extends React.Component<IProductEngraving> {
    @lazyInject(serviceNames.productEngravingViewController)
    @observable
    private productEngravingViewController: ProductEngravingViewController;

    get engravingData() {
        const {
            skuId,
            perlgem: { SKU_BASE_ID },
            selectedSize: { value },
            formattedOriginalPrice,
            parentProduct: { displayName }
        } = this.props.selectedSku;

        return {
            skuId,
            skuBaseId: SKU_BASE_ID,
            size: value,
            price: formattedOriginalPrice,
            name: displayName
        };
    }

    private openProductEngraving = () => {
        const { openEngraving } = this.productEngravingViewController;

        openEngraving(this.engravingData);
    };

    public render() {
        const { engravingLink } = this.props.translations as ITranslationsCollection;
        const { path: engravingLinkPath, title: engravingLinkTitle } = engravingLink;
        const { className } = this.props;
        const openEngravingClassNames = classes('product-engraving-open-modal');

        return (
            engravingLinkPath && (
                <StyledEngraveContent className={className}>
                    <StyledEngraveLink
                        onClick={this.openProductEngraving}
                        className={openEngravingClassNames}
                    >
                        {engravingLinkTitle}
                    </StyledEngraveLink>
                </StyledEngraveContent>
            )
        );
    }
}
